export default "__VITE_ASSET__BfKe4Nnz__"